import { Box, Title } from '@mantine/core';
import { config } from '../config';

const env = config.environment;

export const HomePage = () => {
  return (
    <Box>
      <Title order={1}>Information: This is the {env} system </Title>
      <p>
        {' '}
        You will find that the system is slightly different to the old one, in
        that you can now assign multiple licenses to one organisation.
      </p>
      <Title order={2}>Organisations & Licenses</Title>
      <p>
        {' '}
        Organisations are managed via the API Keys menu item, here you will see
        existing organisations as well as being able to create new ones.
        <br /> There is one API key per application that the organisation owns,
        when creating a new API Key you will either be able to select an
        existing organisation to attach it to, or create a new organisation by
        simply typing it in the box
        <br />
      </p>
      <Title order={3}>API Keys</Title>
      <p>
        This is what would have been known as the license in the previous
        application. When looking at API keys the SCOPE is the application and
        this is what is sent in by the requesting application.
        <br /> The "license" to be given to customers to enter in their
        application is the KEY (License string) field. <br />
      </p>
      <Title order={3}>Licenses</Title>
      <p>
        The KEY is now linked to LICENSES which form the individual items the
        organisation has access for, for example VRNs for making tax digital or
        CLIENTS for OCR
      </p>
      <Title order={2}>Apps</Title>
      <p>
        Do not mess with apps, once configured they should not be edited unless
        really necessary!
        <br />
        However should you want to create a NEW application you can do so by
        going to apps and Create App and filling out the fields
      </p>
      <ul>
        <li>
          <b>Name</b> is the human readable name
        </li>
        <li>
          <b>Short Name</b> is the SCOPE that will need to be sent to the API by
          the requesting application
        </li>
        <li>
          <b>Required license fields</b> These are fields that will be used to
          match a license to an installation. e.g. `client` and the name will
          need to match the key being sent to the API in the request body
        </li>
        <li>
          <b>Shared license data</b>This data will be returned on every license
          check for every license. Note that individual licenses can return
          individual data, such as a client code, OCR queue number etc
        </li>
      </ul>

      <Title order={2}>Usage logs</Title>
      <p>Hopefully self explanatory</p>
    </Box>
  );
};
